import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';
import { featuredComics, latestUpdates, hotRankings, categories } from '@/mocks/comics';
import { injectSchema } from '@/components/base/SEOHead';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  useEffect(() => {
    const orgSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '虚空韩漫网',
      url: 'https://xukonghanman.com',
      description: '虚空韩漫网是专业的韩国漫画在线阅读平台，提供无遮挡下拉式韩漫阅读体验。',
      contactPoint: {
        '@type': 'ContactPoint',
        email: 'contact@xukonghanman.com',
        contactType: 'customer service',
      },
    };
    const webSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: '虚空韩漫网',
      url: 'https://xukonghanman.com',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://xukonghanman.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    };
    const webPageSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '虚空韩漫网 - 首页',
      description: '虚空韩漫网是专业的韩国漫画在线阅读平台，提供无遮挡下拉式韩漫阅读体验。海量韩漫漫画资源每日更新。',
      url: 'https://xukonghanman.com',
      isPartOf: {
        '@type': 'WebSite',
        name: '虚空韩漫网',
      },
    };
    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '虚空韩漫网提供哪些类型的韩国漫画？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '虚空韩漫网提供恋爱浪漫、奇幻冒险、热血动作、都市剧情、搞笑日常、悬疑惊悚、历史古风、BL耽美等多种类型的韩国漫画在线阅读，满足不同读者的偏好。',
          },
        },
        {
          '@type': 'Question',
          name: '什么是无遮挡下拉式韩漫阅读？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '无遮挡下拉式韩漫是虚空韩漫网的核心阅读功能，通过简洁的滚动界面让读者连续阅读漫画内容，无需翻页操作，提供沉浸式的韩国漫画阅读体验。',
          },
        },
        {
          '@type': 'Question',
          name: '虚空韩漫网的漫画更新频率如何？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '虚空韩漫网每日更新海量韩国漫画资源，热门连载作品保持高频更新，让读者第一时间追更心仪的韩漫作品。',
          },
        },
        {
          '@type': 'Question',
          name: '如何在虚空韩漫网找到想看的漫画？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '您可以通过首页的推荐榜单、分类浏览功能、搜索栏或按热度排名来找到感兴趣的韩国漫画。网站提供详细的分类筛选，帮助您快速定位喜欢的作品类型。',
          },
        },
        {
          '@type': 'Question',
          name: '虚空韩漫网是否需要注册才能阅读？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '虚空韩漫网致力于提供简洁无障碍的阅读体验，大部分漫画内容无需注册即可直接在线阅读，让您随时随地畅享韩国漫画。',
          },
        },
      ],
    };

    injectSchema(orgSchema);
    injectSchema(webSchema);
    injectSchema(webPageSchema);
    injectSchema(faqSchema);
  }, []);

  return (
    <>
      <SEOHead
        title="首页"
        description="虚空韩漫网是专业的韩国漫画在线阅读平台，提供无遮挡下拉式韩漫阅读体验。海量韩漫漫画资源每日更新，简洁沉浸的阅读界面让您完全融入漫画情节，随时随地畅享韩国漫画的精彩世界。"
        keywords="虚空韩漫网,韩漫漫画,韩国漫画在线阅读,无遮挡下拉式韩漫"
        canonicalUrl="https://xukonghanman.com"
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <section className="relative w-full h-[520px] md:h-[620px] flex items-center overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20dreamy%20library%20filled%20with%20floating%20books%20and%20scrolls%2C%20warm%20amber%20and%20cream%20tones%2C%20soft%20atmospheric%20light%2C%20abstract%20shapes%2C%20minimalist%20aesthetic%2C%20ethereal%20and%20calm%20mood%2C%20no%20text%2C%20painterly%20texture&width=1600&height=900&seq=hero-bg-manhwa&orientation=landscape"
              alt="虚空韩漫网 - 韩国漫画在线阅读平台"
              title="虚空韩漫网 - 韩国漫画在线阅读"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
            <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6">
              <div className="max-w-2xl">
                <h1 className="text-3xl md:text-5xl font-heading font-bold text-white leading-tight animate-fade-in-up">
                  虚空韩漫网
                </h1>
                <p className="mt-4 md:mt-6 text-base md:text-lg text-white/85 leading-relaxed animate-fade-in-up-delay-1 max-w-xl">
                  专业的<strong>韩国漫画在线阅读</strong>平台，提供<strong>无遮挡下拉式韩漫</strong>阅读体验。
                  海量<strong>韩漫漫画</strong>资源每日更新，简洁沉浸的阅读界面让您完全融入漫画情节。
                </p>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mt-6 md:mt-8 animate-fade-in-up-delay-2">
                  <Link
                    to="/category/romance"
                    className="px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    开始阅读
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                  <Link
                    to="/about"
                    className="px-6 py-3 rounded-lg bg-white/10 hover:bg-white/20 text-white font-medium text-sm transition-colors duration-200 backdrop-blur-sm whitespace-nowrap cursor-pointer"
                  >
                    了解更多
                  </Link>
                </div>
                <div className="flex items-center gap-6 mt-8 animate-fade-in-up-delay-3">
                  <div className="text-center">
                    <p className="text-2xl md:text-3xl font-heading font-bold text-white">2000+</p>
                    <p className="text-xs text-white/60 mt-1">漫画作品</p>
                  </div>
                  <div className="w-px h-10 bg-white/20"></div>
                  <div className="text-center">
                    <p className="text-2xl md:text-3xl font-heading font-bold text-white">50000+</p>
                    <p className="text-xs text-white/60 mt-1">漫画章节</p>
                  </div>
                  <div className="w-px h-10 bg-white/20"></div>
                  <div className="text-center">
                    <p className="text-2xl md:text-3xl font-heading font-bold text-white">100万+</p>
                    <p className="text-xs text-white/60 mt-1">活跃读者</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
            <div className="flex flex-col lg:flex-row gap-10">
              <div className="lg:w-[280px] flex-shrink-0">
                <div className="sticky top-24">
                  <div className="flex items-center gap-2 mb-5">
                    <i className="ri-fire-fill text-primary-500 text-xl"></i>
                    <h2 className="text-lg font-heading font-semibold text-foreground-900">
                      热门排行
                    </h2>
                  </div>
                  <div className="bg-background-100 rounded-lg p-4">
                    {hotRankings.map((item) => (
                      <Link
                        key={item.rank}
                        to={`/comic/${item.slug}`}
                        className="flex items-center gap-3 py-2.5 border-b border-background-200/70 last:border-b-0 hover:bg-background-200/50 rounded-md px-2 -mx-2 transition-colors duration-150 cursor-pointer"
                      >
                        <span className={`w-6 h-6 flex items-center justify-center rounded-md text-xs font-label font-bold ${
                          item.rank <= 3
                            ? 'bg-primary-500 text-white'
                            : 'bg-background-200 text-foreground-500'
                        }`}>
                          {item.rank}
                        </span>
                        <span className="flex-1 text-sm text-foreground-800 font-medium truncate">
                          {item.title}
                        </span>
                        <span className="flex items-center gap-0.5 text-xs text-secondary-500">
                          <i className={`${item.icon} text-[10px]`}></i>
                          {item.heat}
                        </span>
                      </Link>
                    ))}
                  </div>

                  <Link
                    to="/category/romance"
                    className="flex items-center justify-center gap-1 mt-4 text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 font-medium"
                  >
                    查看全部排行
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-2">
                    <i className="ri-sparkling-2-line text-accent-500 text-xl"></i>
                    <h2 className="text-lg font-heading font-semibold text-foreground-900">
                      推荐作品
                    </h2>
                  </div>
                  <div className="flex items-center gap-3">
                    <button className="px-3 py-1.5 rounded-full text-xs font-medium bg-primary-100 text-primary-600 whitespace-nowrap cursor-pointer">
                      全部
                    </button>
                    <button className="px-3 py-1.5 rounded-full text-xs font-medium text-foreground-500 hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                      连载中
                    </button>
                    <button className="px-3 py-1.5 rounded-full text-xs font-medium text-foreground-500 hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                      已完结
                    </button>
                  </div>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                  {featuredComics.slice(0, 8).map((comic) => (
                    <div key={comic.slug}>
                      <Link
                        to={`/comic/${comic.slug}`}
                        className="group cursor-pointer block"
                      >
                        <div className="relative rounded-lg overflow-hidden aspect-[3/4] bg-background-100">
                          <img
                            src={comic.cover}
                            alt={comic.title}
                            title={`${comic.title} - 虚空韩漫网`}
                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                          {comic.isHot && (
                            <div className="absolute top-2 left-2">
                              <span className="px-2 py-0.5 rounded-full text-[10px] font-label font-semibold bg-primary-500 text-white">
                                HOT
                              </span>
                            </div>
                          )}
                          {comic.isNew && (
                            <div className="absolute top-2 left-2">
                              <span className="px-2 py-0.5 rounded-full text-[10px] font-label font-semibold bg-accent-500 text-white">
                                NEW
                              </span>
                            </div>
                          )}
                          {comic.rating && (
                            <div className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-full bg-black/40 text-white text-xs">
                              <i className="ri-star-fill text-secondary-400 text-[10px]"></i>
                              {comic.rating}
                            </div>
                          )}
                        </div>
                        <h3 className="mt-3 font-medium text-foreground-900 text-sm group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                          {comic.title}
                        </h3>
                        <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="bg-background-100">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
                  漫画分类
                </h2>
                <p className="mt-3 text-foreground-500 text-sm max-w-lg mx-auto">
                  探索不同类型的韩国漫画，找到最适合您的阅读偏好
                </p>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex flex-col items-center gap-3 p-6 rounded-lg bg-background-50 hover:bg-background-200/70 transition-colors duration-200 cursor-pointer group"
                  >
                    <div className={`w-14 h-14 rounded-xl flex items-center justify-center ${
                      cat.color === 'primary'
                        ? 'bg-primary-100 text-primary-500'
                        : cat.color === 'accent'
                        ? 'bg-accent-100 text-accent-600'
                        : 'bg-secondary-100 text-secondary-500'
                    } group-hover:scale-110 transition-transform duration-300`}>
                      <i className={`${cat.icon} text-2xl`}></i>
                    </div>
                    <div className="text-center">
                      <h3 className="font-medium text-foreground-900 text-sm group-hover:text-primary-500 transition-colors duration-200">
                        {cat.name}
                      </h3>
                      <p className="text-xs text-foreground-500 mt-1">{cat.count}部作品</p>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </section>

          <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
            <div className="flex items-center justify-between mb-8">
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500 text-xl"></i>
                <h2 className="text-lg font-heading font-semibold text-foreground-900">
                  最近更新
                </h2>
              </div>
              <Link
                to="/category/romance"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 font-medium flex items-center gap-1"
              >
                更多更新
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
              {latestUpdates.slice(0, 10).map((comic, index) => (
                <Link
                  key={`${comic.slug}-${index}`}
                  to={`/comic/${comic.slug}`}
                  className="flex items-center gap-3 p-3 rounded-lg hover:bg-background-100 transition-colors duration-200 cursor-pointer group"
                >
                  <div className="w-14 h-[74px] rounded-md overflow-hidden flex-shrink-0 bg-background-100">
                    <img
                      src={comic.cover}
                      alt={comic.title}
                      title={comic.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-500 transition-colors duration-200">
                      {comic.title}
                    </h4>
                    <p className="text-xs text-foreground-500 mt-1">{comic.chapter}</p>
                    <p className="text-xs text-accent-500 mt-1">{comic.updatedTime}</p>
                  </div>
                </Link>
              ))}
            </div>
          </section>

          <section className="bg-background-100">
            <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20">
              <div className="text-center mb-10">
                <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
                  常见问题
                </h2>
                <p className="mt-3 text-foreground-500 text-sm">
                  关于虚空韩漫网的常见疑问解答
                </p>
              </div>
              <div className="max-w-3xl mx-auto space-y-3">
                {[
                  {
                    q: '虚空韩漫网提供哪些类型的韩国漫画？',
                    a: '虚空韩漫网提供恋爱浪漫、奇幻冒险、热血动作、都市剧情、搞笑日常、悬疑惊悚、历史古风、BL耽美等多种类型的韩国漫画在线阅读，满足不同读者的偏好。',
                  },
                  {
                    q: '什么是无遮挡下拉式韩漫阅读？',
                    a: '无遮挡下拉式韩漫是虚空韩漫网的核心阅读功能，通过简洁的滚动界面让读者连续阅读漫画内容，无需翻页操作，提供沉浸式的韩国漫画阅读体验，让阅读更加流畅自然。',
                  },
                  {
                    q: '虚空韩漫网的漫画更新频率如何？',
                    a: '虚空韩漫网每日更新海量韩国漫画资源，热门连载作品保持高频更新，让读者第一时间追更心仪的韩漫作品，不再错过任何精彩剧情。',
                  },
                  {
                    q: '如何在虚空韩漫网找到想看的漫画？',
                    a: '您可以通过首页的推荐榜单、分类浏览功能、搜索栏或按热度排名来找到感兴趣的韩国漫画。网站提供详细的分类筛选和智能推荐，帮助您快速定位喜欢的作品类型。',
                  },
                  {
                    q: '虚空韩漫网是否需要注册才能阅读？',
                    a: '虚空韩漫网致力于提供简洁无障碍的阅读体验，大部分韩国漫画内容无需注册即可直接在线阅读，让您随时随地畅享韩国漫画的精彩世界。',
                  },
                ].map((faq, index) => (
                  <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors duration-200 list-none">
                      <h4 className="text-sm font-medium text-foreground-900 pr-8">
                        {faq.q}
                      </h4>
                      <i className="ri-add-line text-foreground-400 group-open:hidden flex-shrink-0"></i>
                      <i className="ri-subtract-line text-foreground-400 hidden group-open:block flex-shrink-0"></i>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-20 text-center">
            <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900">
              开启您的韩漫之旅
            </h2>
            <p className="mt-4 text-foreground-500 max-w-lg mx-auto text-sm leading-relaxed">
              加入百万读者的行列，在虚空韩漫网享受最纯粹的<strong>韩国漫画在线阅读</strong>体验。
              无遮挡下拉式阅读，让每一页都流畅如丝。
            </p>
            <Link
              to="/category/romance"
              className="inline-flex items-center gap-2 mt-8 px-8 py-3.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              立即开始阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}